module.exports = __webpack_public_path__ + "media/fonts/formular-bold-webfont-38ce92cecb996799312e1571c1538187.woff";